import { render, staticRenderFns } from "./JVxeUploadCell.vue?vue&type=template&id=4e5ff315&scoped=true"
import script from "./JVxeUploadCell.vue?vue&type=script&lang=js"
export * from "./JVxeUploadCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ff315",
  null
  
)

export default component.exports